import { fontStyles } from '@/components/pdf/styles';
import { deserialiseAddress } from '@/pages/onboarding/commonSteps/addressHelper';
import { PurchaseOrderBundle, PurchaseOrderDeliveryOption } from '@/services/api/contracts/catalog/bundles';
import { Company, MspDetailsForCompany } from '@/services/api/contracts/companies';
import { Text, View } from '@react-pdf/renderer';
import { FunctionComponent } from 'react';

interface PurchaseOrderDocumentDeliverySectionProps {
  order: PurchaseOrderBundle;
  msp: MspDetailsForCompany;
  customer: Company;
}

const PurchaseOrderDocumentDeliverySection: FunctionComponent<PurchaseOrderDocumentDeliverySectionProps> = ({
  order,
  msp,
  customer
}) => {
  const customerAddress = deserialiseAddress(customer.registeredInfo.address);
  const mspAddress = deserialiseAddress(msp.address);

  return (
    <View
      style={{
        flexDirection: 'row',
        width: '100%',
        justifyContent: 'space-between'
      }}
    >
      <View
        style={{
          flexDirection: 'column',
          fontSize: 10,
          marginRight: 15
        }}
      >
        <Text style={{ ...fontStyles.bold, marginRight: 10, marginBottom: 1 }}>Prepared by:</Text>
        <View style={{ ...fontStyles.italic, flexDirection: 'column' }}>
          <Text>{msp.name}</Text>
          <Text>
            {mspAddress?.addressLine1}
            {mspAddress?.addressLine2 ? `, ${mspAddress?.addressLine2}` : ''}
          </Text>
          <Text>{mspAddress?.townCity}</Text>
          <Text>{mspAddress?.stateCounty}</Text>
          <Text>{mspAddress?.postalCode}</Text>
          <Text>{mspAddress?.country}</Text>
        </View>
      </View>
      <View
        style={{
          flexDirection: 'column',
          fontSize: 10,
          marginRight: 15
        }}
      >
        <Text style={{ ...fontStyles.bold, marginRight: 10, marginBottom: 1 }}>Prepared for:</Text>
        <View style={{ ...fontStyles.italic, flexDirection: 'column' }}>
          <Text>{customer.name}</Text>
          <Text>
            {customerAddress?.addressLine1}
            {customerAddress?.addressLine2 ? `, ${customerAddress?.addressLine2}` : ''}
          </Text>
          <Text>{customerAddress?.townCity}</Text>
          <Text>{customerAddress?.stateCounty}</Text>
          <Text>{customerAddress?.postalCode}</Text>
          <Text>{customerAddress?.country}</Text>
        </View>
      </View>
      <View
        style={{
          flexDirection: 'column',
          fontSize: 10,
          marginRight: 15
        }}
      >
        <Text style={{ ...fontStyles.bold, marginRight: 10, marginBottom: 1 }}>Deliver To:</Text>
        <View style={{ ...fontStyles.italic, flexDirection: 'column' }}>
          {order.deliveryOption === PurchaseOrderDeliveryOption.Daas && <Text>DaaS Stock</Text>}
          {order.deliveryOption === PurchaseOrderDeliveryOption.Msp && <Text>{msp.name}</Text>}
          {order.deliveryOption === PurchaseOrderDeliveryOption.Custom && (
            <>
              <Text>{order.address?.name}</Text>
              <Text>
                {order.address?.line1}
                {order.address?.line2 ? `, ${order.address?.line2}` : ''}
              </Text>
              <Text>{order.address?.city}</Text>
              <Text>{order.address?.state}</Text>
              <Text>{order.address?.postcode}</Text>
              <Text>{order.address?.country}</Text>

              <Text>{order.contactDetail?.workEmail}</Text>
              {order.contactDetail?.personalEmail && <Text>{order.contactDetail?.personalEmail}</Text>}
              <Text>{order.contactDetail?.telephoneNumber}</Text>
            </>
          )}
        </View>
      </View>
    </View>
  );
};

export default PurchaseOrderDocumentDeliverySection;
